import { Component, OnInit } from '@angular/core';
import { RegoService } from 'src/app/rego.service';
import { Router, ActivatedRoute } from '@angular/router';
declare var geoip2: any;
declare var swal: any;
declare var encryptAndRedirectToMID: any;

const AccessCodes = [
  {
    uuid: 'dd8ed21e-d879-4001-9390-71af84d117fd',
    passcode: '2024WSDV',
  },
  {
    uuid: '3ec4f29d-ab84-42b9-9c8c-a7a2b1bbaf72',
    passcode: '2024WSDFTF',
  },
]

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  buttonText = 'Create account';
  // recaptchaKey = RESOURCES.RECAPTCHAKEY;
  recaptchaKey = '';

  listSelected = null;

  lists = {
    countries: {
      label: 'Country of Residence'
    },
    professions: {
      label: 'Profession'
    },
    specialties: {
      label: 'Specialty'
    },
    conditions: {
      label: 'Condition'
    }
  };

  refdata = {
    countries: [],
    professions: [],
    specialties: [],
    conditions: []
  };


  errorMessage = '';
  emailFormat = new RegExp(/^[^@]+@[^.]+\..*/);
  regex = new RegExp(/^[a-zA-Z]{3}\d{10}/);

  country = 'AU';
  roleSelection = {
    role: '',
    otherRole: '',
  }

  participations = {
    virtual: false,
    faceToFace: false,
  }

  registrationForm = {
    version: 5,
    uInteractTsAndCs: 'N',
    uSAMTrackingConsent: 'N',
    uiCloudConsent: 'N',
    uGoogleConsent: 'N',
    uFacebookConsent: 'N',
    title: null,
    firstName: '',
    lastName: '',
    emailAddress: '',
    password: '',
    profession: null,
    otherProfession: '',
    otherSpecialty: '',
    specialty: null,
    condition: null,
    countryCode: 'AU',
    recaptchaResponse: null,
    storeContactIdentifiers: false,
    qrAccessCodes: [],
    contactDetails: {
      company: '',
      dateOfBirth: '',
      countryCode: 'AU',
      postCode: '',
      contactCategory: '',
      contactProfession: '',
      contactSpecialty: '',
      ownedBy: '',
      notes: '',
      dietaryRequirements: null,
      phone: '',
      mobile: '',
      wallConsent1: '',
      wallConsent2: '',
      additional1: '',
      additional2: '',
      additional3: '',
    }
  };
  confirmPassword = '';
  loading = false;
  checkBox2 = false;
  interactAgree = false;

  constructor(private regoService: RegoService) {
    if (window.location.hostname === 'localhost') {
      this.recaptchaKey = '6Lc3hxIUAAAAAC_-d8oueRR9jtUUugcltkbDgZE2'; // localhost
    } else {
      this.recaptchaKey = '6LfV2S0UAAAAAByxHbcvS8D2F-ErWZsunv5Vmqhe';
    }
  }

  ngOnInit() {
  }

  resetForm() {
    this.interactAgree = false;
    this.checkBox2 = false;
    this.participations = {
      virtual: false,
      faceToFace: false,
    }
    this.confirmPassword = ''
    this.registrationForm = {
      version: 5,
      uInteractTsAndCs: 'N',
      uSAMTrackingConsent: 'N',
      uiCloudConsent: 'N',
      uGoogleConsent: 'N',
      uFacebookConsent: 'N',
      title: null,
      firstName: '',
      lastName: '',
      emailAddress: '',
      password: '',
      profession: null,
      otherProfession: '',
      otherSpecialty: '',
      specialty: null,
      condition: null,
      countryCode: 'AU',
      recaptchaResponse: null,
      storeContactIdentifiers: false,
      qrAccessCodes: [],
      contactDetails: {
        company: '',
        dateOfBirth: '',
        countryCode: 'AU',
        postCode: '',
        contactCategory: '',
        contactProfession: '',
        contactSpecialty: '',
        ownedBy: '',
        notes: '',
        dietaryRequirements: null,
        phone: '',
        mobile: '',
        wallConsent1: '',
        wallConsent2: '',
        additional1: '',
        additional2: '',
        additional3: '',
      }
    };
    this.roleSelection = {
      role: null,
      otherRole: '',
    };
    this.country = '';
  }

  resolved(captchaResponse: string) {
    this.registrationForm.recaptchaResponse = captchaResponse;
  }

  submit() {
    // if (this.participations.virtual) {
    this.registrationForm.qrAccessCodes = ['2024WSDV'];
    // }
    //
    // if (this.participations.faceToFace) {
    //   this.registrationForm.qrAccessCodes.push('2024WSDFTF');
    // }

    if (this.interactAgree === true) {
      this.registrationForm.uInteractTsAndCs = 'Y';
      this.registrationForm.uSAMTrackingConsent = 'Y';
      this.registrationForm.uiCloudConsent = 'Y';
      this.registrationForm.uGoogleConsent = 'Y';
      this.registrationForm.uFacebookConsent = 'Y';
    } else {
      this.registrationForm.uInteractTsAndCs = 'N';
      this.registrationForm.uSAMTrackingConsent = 'N';
      this.registrationForm.uiCloudConsent = 'N';
      this.registrationForm.uGoogleConsent = 'N';
      this.registrationForm.uFacebookConsent = 'N';
    }

    this.registrationForm.specialty = '8'; // "Endocrinology"
    this.registrationForm.contactDetails.contactSpecialty = 'Endocrinology';
    if (this.roleSelection.role === 'General Practitioner') {
      this.registrationForm.profession = '1';
    }
    if (this.roleSelection.role === 'Nurse Practitioner') {
      this.registrationForm.profession = '2';
    }
    if (this.roleSelection.role === 'Community Nurse') {
      this.registrationForm.profession = '2';
    }
    if (this.roleSelection.role === 'Dietitian') {
      this.registrationForm.profession = '5';
      this.registrationForm.otherProfession = 'Dietitian';
    }
    if (this.roleSelection.role === 'Podiatrist') {
      this.registrationForm.profession = '5';
      this.registrationForm.otherProfession = 'Podiatrist';
    }
    if (this.roleSelection.role === 'Exercise physiologist') {
      this.registrationForm.profession = '5';
      this.registrationForm.otherProfession = 'Exercise physiologist';
    }
    if (this.roleSelection.role === 'Optometrist') {
      this.registrationForm.profession = '1';
      this.registrationForm.otherProfession = 'Optometrist';
      this.registrationForm.specialty = '22'; // "Ophthalmology"
      this.registrationForm.contactDetails.contactSpecialty = 'Ophthalmology';
    }
    if (this.roleSelection.role === 'Specialist Physician') {
      this.registrationForm.profession = '1';
      this.registrationForm.otherProfession = 'Specialist Physician';
    }
    if (this.roleSelection.role === 'JMO') {
      this.registrationForm.profession = '5';
      this.registrationForm.otherProfession = 'JMO';
    }
    if (this.roleSelection.role === 'Diabetes Educator') {
      this.registrationForm.profession = '2';
      this.registrationForm.otherProfession = 'Diabetes Educator';
    }
    if (this.roleSelection.role === 'Psychologist') {
      this.registrationForm.profession = '5';
      this.registrationForm.otherProfession = 'Psychologist';
    }
    if (this.roleSelection.role === 'Pharmacist') {
      this.registrationForm.profession = '3';
    }
    if (this.roleSelection.role === 'Pharmacist') {
      this.registrationForm.profession = '5';
      this.registrationForm.otherProfession = 'Pharmacist';
    }

    this.registrationForm.contactDetails.contactProfession = this.roleSelection.role;

    if (this.roleSelection.role === 'Other') {
      this.registrationForm.profession = '7';
      this.registrationForm.otherProfession = this.roleSelection.otherRole;
      this.registrationForm.contactDetails.contactProfession = this.roleSelection.otherRole;
    }

    this.registrationForm.countryCode = this.country;
    this.registrationForm.contactDetails.countryCode = this.country;

    if (this.formValid()) {
      this.loading = true;
      this.regoService.register(this.registrationForm).then(result => {
        this.loading = false;
        grecaptcha.reset();
        this.responseHandling(result);
        this.resetForm();
      }).catch(err => {
        console.log(err);
        this.registrationForm.qrAccessCodes = [];
        this.loading = false;
        alert('Error');
      });
    }
  }

  formValid() {
    // if (!this.participations.virtual && !this.participations.faceToFace) {
    //   swal({title: 'Form is invalid', text: 'Please select your preferred attendance;.', html: true, type: 'error'});
    //
    //
    //   return false;
    // }
    //
    if (this.registrationForm.title === null) {
      swal({title: 'Form is invalid', text: 'Title is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.firstName === '') {
      swal({title: 'Form is invalid', text: 'First Name is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.lastName === '') {
      swal({title: 'Form is invalid', text: 'Last Name is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.emailAddress === '') {
      swal({title: 'Form is invalid', text: 'Email is a required field.', html: true, type: 'error'});
      return false;
    }
    if (!this.emailFormat.test(this.registrationForm.emailAddress)) {
      swal({title: 'Form is invalid', text: 'Please enter a valid email address.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.contactDetails.phone === '') {
      swal({title: 'Form is invalid', text: 'Phone Number is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.country === '') {
      swal({title: 'Form is invalid', text: 'Country must be selected.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.contactDetails.company === '') {
      swal({title: 'Form is invalid', text: 'Practice/Organisation is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.contactDetails.ownedBy === '') {
      swal({title: 'Form is invalid', text: 'Please select where you predominantly work.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.contactDetails.postCode === '') {
      swal({title: 'Form is invalid', text: 'Postcode is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.roleSelection.role === '') {
      swal({title: 'Form is invalid', text: 'Job Title is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.roleSelection.role ==='Other' && this.roleSelection.otherRole === '') {
      swal({title: 'Form is invalid', text: 'Other Job Title is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.password === '') {
      swal({title: 'Form is invalid', text: 'Password is a required field.', html: true, type: 'error'});
      return false;
    } else if (this.registrationForm.password.length < 8) {
      swal({title: 'Form is invalid', text: 'Password must be at least 8 characters.', html: true, type: 'error'});
      return false;
    }
    if (this.confirmPassword === '') {
      swal({title: 'Form is invalid', text: 'Confirm Password is a required field.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.password !== this.confirmPassword) {
      swal({title: 'Form is invalid', text: 'The password and confirmation password do not match.', html: true, type: 'error'});
      return false;
    }
    if (!this.validatePassword(this.registrationForm.password)) {
      swal({title: 'Form is invalid', text: 'Password must be at least 8 characters and must include 1 uppercase letter, 1 lowercase letter, and 1 number.', html: true, type: 'error'});
      return false;
    }
    if (this.registrationForm.recaptchaResponse === null) {
      swal({title: 'Form is invalid', text: 'Recaptcha is required.', html: true, type: 'error'});
      return false;
    }
    // if (this.registrationForm.contactDetails.contactCategory === '') {
    //   swal({title: 'Form is invalid', text: 'AHPRA number is a required field.', html: true, type: 'error'});
    //   return false;
    // }
    // else if (!this.regex.test(this.registrationForm.contactDetails.contactCategory)) {
    //   swal({title: 'Form is invalid', text: 'AHPRA number is invalid, must be 3 letters followed by 10 digits.', html: true, type: 'error'});
    //   return false;
    // }

    if (!this.interactAgree) {
      swal({title: 'Form is invalid', text: 'You must agree to the INTERACT terms and conditions', html: true, type: 'error'});
      return false;
    }

    return true;
  }

  validatePassword(password) {
    return /[A-Z]/.test(password) &&
          /[a-z]/.test(password) &&
          /[0-9]/.test(password) &&
          password.length >= 8;
  }

  responseHandling(response) {
    const access = AccessCodes.find((accessCode) => {
      if (this.registrationForm.qrAccessCodes.length === 0) {
        return false;
      }

      return accessCode.passcode === this.registrationForm.qrAccessCodes[0];
    });

    if (response.status.code === 0) {
      const alertTitle = 'Registration is successful';
      const msg = 'You will now be redirected';
      swal({title: alertTitle, text: msg, html: true, type: 'success'});
      encryptAndRedirectToMID(this.registrationForm.emailAddress, this.registrationForm.password, access.uuid);
    } else if (response.status.code === 1002) {
      const alertTitle = 'An error has occurred';
      if (response.data.errorCode === 1002) {
        if (response.data.errorCode === 1050) {
          const alertTitle = 'Registration is successful';
          const msg = 'You will now be redirected';
          swal({title: alertTitle, text: msg, html: true, type: 'error'});
          encryptAndRedirectToMID(this.registrationForm.emailAddress, this.registrationForm.password, access.uuid);
        } else {
          const msg = 'Error: ' + response.data.errorMsg;
          swal({title: alertTitle, text: msg, html: true, type: 'error'});
        }
      } else if (response.data.errorCode === 1010) {
        const msg = 'Error: ' + response.data.errorMsg;
        swal({title: alertTitle, text: msg, html: true, type: 'error'});
      } else if (response.data.errorCode === 1033) {
        const msg = 'Error: ' + response.data.errorMsg;
        swal({title: alertTitle, text: msg, html: true, type: 'error'});
      } else {
        const msg = 'Error: ' + response.data.errorMsg;
        swal({title: alertTitle, text: msg, html: true, type: 'error'});
      }
    }
  }
}
